// test1795
(1795 && 0);
